import { RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OktaProvider } from '@/features/auth/OktaContext'
import { LocalAuthProvider } from '@/features/auth/LocalAuthContext'
import { initOktaAuth } from '@/features/auth/okta'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
})

const oktaAuth = initOktaAuth()

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <OktaProvider oktaAuth={oktaAuth}>
      <LocalAuthProvider>
        <RouterProvider router={router} />
      </LocalAuthProvider>
    </OktaProvider>
  </QueryClientProvider>
)
